var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 1H1V50H50V1Z",
    stroke: "#FFCB00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.291 22.1566H18.2247V36H14.291V22.1566ZM17.9438 15.5956C18.3135 15.9531 18.5352 16.4625 18.5499 17.0701C18.5485 17.6513 18.3312 18.1575 17.9533 18.52C17.5745 18.8832 17.0057 19.1288 16.2585 19.1288H16.2263C14.835 19.1288 14 18.2013 14 17.0646C14 16.4673 14.2239 15.96 14.6058 15.5999C14.9886 15.2389 15.5586 15 16.2912 15C17.0225 15 17.574 15.2379 17.9438 15.5956Z",
    fill: "#FFCB00",
    stroke: "#FFCB00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8893 22.1568V23.6117L25.4422 24.3095H26.3564H26.3893H26.8893V23.9084C27.187 23.4649 27.5742 22.9799 28.1298 22.5875C28.7498 22.1496 29.6062 21.8086 30.8357 21.8086C32.3472 21.8086 33.6233 22.2996 34.5253 23.2781C35.431 24.2606 36.0157 25.7957 36.0157 27.9893V36.0003H32.0824V28.5594C32.0824 27.5162 31.8981 26.5601 31.4153 25.8513C30.9108 25.1107 30.123 24.7028 29.0829 24.7028C27.4497 24.7028 26.4929 25.8146 26.0882 26.819C25.9179 27.2351 25.8892 27.7657 25.8892 28.2111V36.0004H21.9579L21.9582 35.9219C21.9599 35.5513 21.9621 35.0204 21.9647 34.3789C21.9697 33.096 21.9758 31.3708 21.9799 29.602C21.9867 26.6123 21.988 23.476 21.968 22.1568H25.8893Z",
    fill: "#FFCB00",
    stroke: "#FFCB00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinked);
export default __webpack_public_path__ + "static/media/linked.1e2866dff123c611eb897aa830aa4dec.svg";
export { ForwardRef as ReactComponent };